/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Cancel_KeepInputs */



/**
* | output |
* | --- |
* | "Keep running" |
*
* @param {Agent_Run_Cancel_KeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_cancel_keep = /** @type {((inputs?: Agent_Run_Cancel_KeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Cancel_KeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weiterlaufen lassen")
	return /** @type {LocalizedString} */ ("Keep running")
});